package com.flowyride.core.fileexport

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update

/**
 * Files handed to the app by the system ("Ouvrir avec FlowyRide", share sheet), waiting for the screen that imports them.
 *
 * The platform entry point [offer]s; the planner [consume]s once it is on screen (the rider may be signed out or
 * navigating when the file arrives). Only the latest file is kept.
 */
class OpenedFiles {
    private val _pending = MutableStateFlow<Result<PickedFile>?>(null)

    /** The file to import, or why it could not be read; null when nothing is waiting. */
    val pending: StateFlow<Result<PickedFile>?> = _pending.asStateFlow()

    fun offer(file: Result<PickedFile>) {
        _pending.value = file
    }

    /** Removes [file] if it is still the pending one: a newer file offered meanwhile stays. */
    fun consume(file: Result<PickedFile>) {
        _pending.update { if (it == file) null else it }
    }
}
